import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { mountWidget } from '../../../../packages/widget/src/widget';
import { browserLocale, dictionaries } from '../../../../packages/widget/src/i18n';

export function DemoPage() {
  const { publicAgentId } = useParams();
  const container = useRef<HTMLDivElement>(null);
  const [locale, setLocale] = useState(() => browserLocale(publicAgentId ?? ''));
  const text = dictionaries[locale];
  useEffect(() => {
    const previousTitle = document.title;
    const abort = new AbortController();
    if (publicAgentId && container.current) {
      void mountWidget({
        agentId: publicAgentId,
        apiBaseUrl: String(import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000'),
        container: container.current,
        signal: abort.signal,
        onLocaleChange: setLocale,
      });
    }
    return () => {
      abort.abort();
      document.title = previousTitle;
    };
  }, [publicAgentId]);
  useEffect(() => {
    document.title = `${text.title} | 24talk`;
  }, [text.title]);

  return (
    <main className="demo-page" lang={locale}>
      <header>
        <img
          className="demo-brand-logo"
          src="/brand/logo-landscape-transparent-290.png"
          width={290}
          height={164}
          alt="24talk"
        />
      </header>
      <div className="demo-experience">
        <figure className="demo-integration-preview">
          <figcaption className="demo-callout demo-callout-site">
            <p>{text.websiteCallout}</p>
            <svg viewBox="0 0 190 86" aria-hidden="true" focusable="false">
              <path className="demo-arrow-shadow" d="M8 12 C55 3 125 7 157 24 C177 35 164 61 139 70" />
              <path className="demo-arrow-line" d="M8 12 C55 3 125 7 157 24 C177 35 164 61 139 70" />
              <path className="demo-arrow-shadow" d="M142 53 L138 71 L158 65" />
              <path className="demo-arrow-line" d="M142 53 L138 71 L158 65" />
            </svg>
          </figcaption>
          <img
            src="/illustrations/demo-integrated-site.png"
            width={1536}
            height={1024}
            alt={text.integrationPreviewAlt}
            loading="lazy"
            decoding="async"
          />
        </figure>
        <section className="demo-chat-demo" aria-labelledby="demo-chat-callout">
          <div className="demo-callout demo-callout-chat">
            <p id="demo-chat-callout">{text.chatCallout}</p>
            <svg viewBox="0 0 190 86" aria-hidden="true" focusable="false">
              <path className="demo-arrow-shadow" d="M14 12 C68 1 141 4 165 25 C183 41 163 62 112 70" />
              <path className="demo-arrow-line" d="M14 12 C68 1 141 4 165 25 C183 41 163 62 112 70" />
              <path className="demo-arrow-shadow" d="M116 53 L110 71 L132 67" />
              <path className="demo-arrow-line" d="M116 53 L110 71 L132 67" />
            </svg>
          </div>
          <div className="demo-chat" ref={container} />
        </section>
      </div>
      <footer>
        <p>{text.disclaimer}</p>
        <p>{text.privacy}</p>
        <p>{text.human}</p>
      </footer>
    </main>
  );
}
